module.exports = __webpack_public_path__ + "static/img/top_bg_text.eb6f9adb.jpg";